module.exports = __webpack_public_path__ + "static/returns-fe20913e8cb2fb5b8e8d915c13385a14.png";